module.exports = __webpack_public_path__ + "img/konfigurasi_cod.87021b3a.svg";